import { PlusOutlined } from "@ant-design/icons"
import {
  Button,
  Col,
  Drawer,
  Form,
  Input,
  InputNumber,
  message,
  Row,
  Select,
  Space,
  Typography,
} from "antd"
import { addDoc, collection, serverTimestamp } from "firebase/firestore"
import React, { useState } from "react"
import { db } from "../../../firebase/config"
import { useCollection } from "../../../hooks/useCollection"
const { Option } = Select
const { Paragraph } = Typography

function CreateWarehouseMaterial() {
  const { data: materialSuppliers, loading: materialSupplierLoading } =
    useCollection("materialSuppliers")
  const [open, setOpen] = useState(false)

  //material info
  const [material, setMaterial] = useState("")
  const [eurM2, setEurM2] = useState(0)
  const [gM2, setGM2] = useState(0)
  const [stock, setStock] = useState(false)
  const [comment, setComment] = useState("")
  const [slogan, setSlogan] = useState(null)
  const [supplierMaterialName, setSupplierMaterialName] = useState(null)
  const [selectedSupplier, setSelectedSupplier] = useState({})
  const [materialFor, setMaterialFor] = useState("Labels")
  const [widths, setWidths] = useState([])

  const showDrawer = () => {
    setOpen(true)
  }
  const onClose = () => {
    setOpen(false)
  }

  const resetFields = () => {
    setMaterial("")
    setEurM2(0)
    setGM2(0)
    setStock(false)
    setSlogan(null)
    setComment("")
  }

  const handleAddMaterial = async (e) => {
    e.preventDefault()
    const ref = collection(db, "materials")
    try {
      await addDoc(ref, {
        material: material,
        eurM2: eurM2,
        gM2: gM2,
        stock: stock,
        slogan: slogan,
        supplier: selectedSupplier,
        supplierMaterialName: supplierMaterialName,
        comment: comment,
        created: serverTimestamp(),
        materialFor: materialFor,
        widths: widths,
      })
        .then(() => {
          message.success(`Success! Material ${material} has been created.`)
        })
        .then(() => {
          setOpen(false)
          resetFields()
        })
    } catch (err) {
      message.error(err.message)
    }
  }

  //handles the width change
  const handleWidthChange = (value) => {
    const numberArray = value.map((str) => parseInt(str, 10)).filter((num) => !isNaN(num)) //transforms into numbers aswell
    setWidths(numberArray)
  }

  const handleKeyDown = (e) => {
    // Allow only numbers and comma
    if (!/[0-9,]/.test(e.key)) {
      e.preventDefault()
    }
  }

  //handle material for
  const handleMaterialFor = (value) => {
    setMaterialFor(value)
  }

  const handleOnBlur = (event) => {
    const newValue = event.target.value.replace(/,/g, ".")
    setGM2(Number(newValue))
  }

  const handleOnKeyPress = (event) => {
    if (event.key === ",") {
      event.preventDefault()
    }
  }

  //handles supplier change
  const changeSelectedSupplier = (value, object) => {
    setSelectedSupplier(object)
  }

  return (
    <>
      <Button type="primary" onClick={showDrawer} icon={<PlusOutlined />}>
        New Material
      </Button>
      <Drawer
        title="Create material"
        width={700}
        onClose={onClose}
        open={open}
        bodyStyle={{
          paddingBottom: 80,
        }}
        extra={
          <Space>
            <Button onClick={onClose}>Cancel</Button>
            <Button onClick={handleAddMaterial} type="primary">
              Create
            </Button>
          </Space>
        }>
        <button onClick={() => console.log(widths)}>log</button>
        <Form layout="vertical" style={{ width: "100%" }}>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="material"
                label="Material Name"
                rules={[
                  {
                    required: true,
                    message: "Please enter Material Name",
                  },
                ]}>
                <Input
                  value={material}
                  placeholder="Please enter Material Name"
                  onChange={(event) => setMaterial(event.target.value)}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="eurM2"
                label="Euro M2"
                rules={[
                  {
                    required: true,
                    message: "Please enter EurM2",
                  },
                ]}>
                <InputNumber
                  onKeyPress={handleOnKeyPress}
                  onBlur={handleOnBlur}
                  type="number"
                  onChange={setEurM2}
                  style={{ width: "100%" }}
                  placeholder="Please input EurM2"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item
                name="gM2"
                label="Grams M2"
                rules={[
                  {
                    required: true,
                    message: "Please enter Grams M2",
                  },
                ]}>
                <InputNumber
                  onKeyPress={handleOnKeyPress}
                  onBlur={handleOnBlur}
                  type="number"
                  onChange={setGM2}
                  placeholder="Please input gM2"
                  style={{ width: "100%" }}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                name="instock"
                label="In Stock?"
                rules={[
                  {
                    required: true,
                    message: "Please select if it's in stock",
                  },
                ]}>
                <Select onChange={setStock} placeholder="Is it in stock?">
                  <Option value={false}>No</Option>
                  <Option value={true}>Yes</Option>
                </Select>
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label="Supplier Name" name="supplier">
                <Select
                  showSearch
                  style={{
                    width: "100%",
                  }}
                  loading={materialSupplierLoading}
                  onChange={changeSelectedSupplier}
                  placeholder="Search for supplier name"
                  optionFilterProp="children"
                  filterOption={(input, option) => (option?.label ?? "").includes(input)}
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? "")
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? "").toLowerCase())
                  }
                  options={materialSuppliers}
                  fieldNames={{ label: "supplierName", value: "id" }}
                />
              </Form.Item>
            </Col>
            <Col span={24}>
              <Form.Item label="Avaiable widths" name="widths">
                <Select
                  mode="tags"
                  style={{
                    width: "100%",
                  }}
                  placeholder="Tags Mode"
                  onChange={handleWidthChange}
                  tokenSeparators={[","]}
                  onInputKeyDown={handleKeyDown} // Restrict keys
                />
                <Paragraph italic style={{ fontSize: "12px", color: "gray" }}>
                  Use "," for width separation
                </Paragraph>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Material Slogan" name="slogan">
                <Input
                  style={{ width: "100%" }}
                  placeholder="Enter material slogan"
                  onChange={(event) => setSlogan(event.target.value)}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Material For" name="materialFor">
                <Select
                  style={{
                    width: "100%",
                  }}
                  placeholder="For what use the material is gonna be"
                  onChange={handleMaterialFor}
                  options={[
                    {
                      value: "Labels",
                      label: "Labels",
                    },
                    {
                      value: "Tapes",
                      label: "Tapes",
                    },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Supplier Material Name" name="supplierMaterialName">
                <Input
                  style={{ width: "100%" }}
                  placeholder="Enter supplier material name"
                  onChange={(event) => setSupplierMaterialName(event.target.value)}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16}>
            <Col span={24}>
              <Form.Item name="comment" label="Comment">
                <Input.TextArea
                  value={comment}
                  onChange={(event) => setComment(event.target.value)}
                  rows={2}
                  placeholder="please enter material comments"
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Drawer>
    </>
  )
}

export default CreateWarehouseMaterial
